<template>
  <section class="product-section-address card">
    <h3 class="title">{{ $t('all_address') }}</h3>
    <p class="py-4 whitespace-pre-wrap">{{ fullAddress }}</p>
    <div class="copy -mt-2 -ml-3">
      <nd-button size="small" type="text" class="active" @click="handleCopyBtnClick">{{ $t('all_copy_address') }}</nd-button>
    </div>
    <div class="flex items-center justify-center aspect-2 mt-4">
      <iframe-map :target="googleMapAddressQueryString" :latitude="props.product.lat" :longitude="props.product.lng" />
    </div>
    <template v-if="props.product.transportation">
      <hr class="my-4" />
      <h3 class="title">{{ $t('public_transportation') }}</h3>
      <p class="py-4 whitespace-pre-wrap" v-html="props.product.transportation"></p>
      <nd-collapse class="!px-0" :list="addressCollapseData" content-class="whitespace-pre-wrap" divider></nd-collapse>
    </template>
  </section>
</template>

<script setup lang="ts">
import IframeMap from '@/components/common/iframe-map.vue'

import type { UiProductInfo } from '@/types/product'

import { useAlertStore } from '@/store/alert'

const { t } = useI18n()

const alertStore = useAlertStore()

const props = defineProps<{
  product: UiProductInfo
}>()

const addressCollapseData = computed(() => {
  if (!props.product) return []

  return [
    {
      title: t('near_by_attractions'),
      content: props.product.nearby_spot,
    },
    {
      title: t('branch_business_hours'),
      content: props.product.opening_hours,
    },
  ]
})

const { fullAddress, googleMapAddressQueryString } = useAddress(props.product)

const { copy } = useClipboard({ source: fullAddress, legacy: true })
const handleCopyBtnClick = () => {
  alertStore.success(t('toast_branch_address_copied'))
  copy()
}
</script>

<style lang="scss" scoped></style>
